import RoleDTO from '../../dto/RoleDTO';
import { ROLE_MODULE } from '../../configs/moduleNames';

export const MODULE_NAME = ROLE_MODULE;
export const MODULE_BACK_PATH = 'roles';
export const MODULE_DTO = RoleDTO;
